// extracted by mini-css-extract-plugin
module.exports = {"checkBoxDiv":"inline-select-styles_checkBoxDiv__1fYTS","square":"inline-select-styles_square__2gh0I","innerCheckbox":"inline-select-styles_innerCheckbox__D88G_"};